import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import React from "react";
import { useDeleteEmailSignature } from "../../../hooks";

const EmailDelete = ({
  openDeleteEmail,
  setOpenDeleteEmail,
  signatureId,
  name,
}: {
  openDeleteEmail: boolean;
  setOpenDeleteEmail: (value: boolean) => void;
  signatureId: string;
  name: string;
}) => {
  const { mutateAsync: deleteEmailSignature } = useDeleteEmailSignature();
  const handleCancel = () => {
    setOpenDeleteEmail(false);
  };

  const handleSubmit = () => {
    deleteEmailSignature(signatureId);
    setOpenDeleteEmail(false);
  };

  return (
    <div>
      {" "}
      <Dialog open={openDeleteEmail} onOpenChange={setOpenDeleteEmail}>
        <DialogContent className="max-w-xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl">
              Delete Email Signature
            </DialogTitle>
            <DialogDescription>
              Are you sure you want to delete this Email Signature?
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4">
            <p className="text-sm text-muted-foreground">
              Are you sure you want to delete the Email Signature "{name}"? This will permanently remove the system and all its
              associated data. This action cannot be undone.
            </p>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Delete</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EmailDelete;
